import {useMutation} from '@apollo/react-hooks';

import type {
    CreateEmailSequenceTemplateGroup,
    CreateEmailSequenceTemplateGroupVariables,
    EmailSequenceTemplateGroupCreateInput,
} from 'nutshell-graphql-types';

import CREATE_EMAIL_SEQUENCE_TEMPLATE_GROUP from '../mutations/create-email-sequence-template-group.graphql';

export function useCreateEmailSequenceTemplateGroup(): {
    createEmailSequenceTemplateGroup: (arg1: EmailSequenceTemplateGroupCreateInput) => Promise<any>;
    isCreating: boolean;
} {
    const [createEmailSequenceTemplateGroup, {loading}] = useMutation<
        CreateEmailSequenceTemplateGroup,
        CreateEmailSequenceTemplateGroupVariables
    >(CREATE_EMAIL_SEQUENCE_TEMPLATE_GROUP);

    return {
        createEmailSequenceTemplateGroup: (input: EmailSequenceTemplateGroupCreateInput) =>
            createEmailSequenceTemplateGroup({
                variables: {input},
            }),
        isCreating: loading,
    };
}
